module.exports = __webpack_public_path__ + "static/overview-booth@2x-bdb6d57a43c0888cfbd0f313d4031894.png";